// extracted by mini-css-extract-plugin
export default {"Agreement":"Agreement--vwp6f","Agreement__error":"Agreement__error--j4_lx"};